import * as types from '../actions/actionTypes';
import {ROUTES} from "../routes";
import {getCurrentLayout} from "../bvcomponents/appLayout";

const initialState = {
  shopPageLoaded: false,
  shopPageOpened: false,
  shopLastPageVisited: ROUTES.shop,
  shopPageLeaved: false,
  // shopActiveCategory: "",
  // shopActiveFeature: "",
};

const getLastVisitedShopPage = (partId, withFeature = null, currentPage = "") => {
  const layout = getCurrentLayout();
  if (!layout.partIdExistInQtCategory(partId, true)) {
    return ROUTES.shop
  }
  if (withFeature) {
    return `${ROUTES.shop}/${partId}/${withFeature.dbFeature.sku || withFeature.dbFeature.sharedFeatureName}`
  }
  if (currentPage && currentPage.includes(partId + "/")) { // + "/" - we are checking if there is anything more (feature opened)
    return currentPage
  }
  return `${ROUTES.shop}/${partId}`
}

export default function (state = initialState, action) {

  switch (action.type) {

    case types.SET_SHOP_PAGE_LOADED:
    case types.SET_SHOP_PAGE_OPENED:
    case types.SET_SHOP_LAST_PAGE_VISITED:
    case types.SET_SHOP_PAGE_LEAVED:
    // case types.SET_SHOP_ACTIVE_CATEGORY:
    // case types.SET_SHOP_ACTIVE_FEATURE:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_LOOK_ACTIVE_CATEGORY: {
      if (!state.shopPageOpened && action.payload.lookActiveCategory) {
        const shopLastPageVisited = getLastVisitedShopPage(action.payload.lookActiveCategory, null, state.shopLastPageVisited);
        if (shopLastPageVisited !== state.shopLastPageVisited) {
          return Object.assign({}, state, {
            shopLastPageVisited
          });
        }
      }
      return state;
    }
    case types.SET_LOOK_ACTIVE_FEATURE: {
      if (!state.shopPageOpened && action.payload.lookActiveFeature) {
        const shopLastPageVisited = getLastVisitedShopPage(action.payload.lookActiveFeature.partId, action.payload.lookActiveFeature, state.shopLastPageVisited);
        if (shopLastPageVisited !== state.shopLastPageVisited) {
          return Object.assign({}, state, {
            shopLastPageVisited
          });
        }
      }
      break;
    }
    // case types.SET_SHOP_ACTIVE_FEATURE:
  }

  return state;

}
